import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';

import { DEFAULT_INDENT_SIZE, DEFAULT_SIZE } from './config';
import type { TCalculatorLayout } from './models';

export const CalculatorLayout: FC<TCalculatorLayout> = ({
    classNames = {},
    disclaimerOnTheLeft,
    error,
    indentSize = DEFAULT_INDENT_SIZE,
    renderCheckboxes,
    renderDisclaimer = null,
    renderResultCard,
    renderResultCardError = null,
    renderSliders,
    resultCardPad = DEFAULT_INDENT_SIZE,
    resultCardWidth = DEFAULT_SIZE,
    styles = {},
    swap,
    swapControls,
}) => {
    const sliders = renderSliders();
    const checkboxes = renderCheckboxes();

    const renderControls = swapControls ? (
        <>
            {sliders}
            {checkboxes}
        </>
    ) : (
        <>
            {checkboxes}
            {sliders}
        </>
    );

    return (
        <div
            className={cn(styles.layout, { [styles.layoutReverse]: swap })}
            data-test-id="calcLayout"
        >
            <div
                className={cn(
                    styles.controls,
                    classNames.controls,
                    styles[`controls-indent-${indentSize}`]
                )}
            >
                {renderControls}
                {disclaimerOnTheLeft && renderDisclaimer && renderDisclaimer()}
            </div>
            <div
                className={cn(
                    styles[`results-card-width-${resultCardWidth}`],
                    classNames.resultCard
                )}
            >
                <div
                    className={cn(
                        styles.resultsCard,
                        styles[`results-card-padding-${resultCardPad}`],
                        classNames.resultsCard
                    )}
                >
                    {error
                        ? renderResultCardError && renderResultCardError()
                        : renderResultCard && renderResultCard()}
                </div>

                {!disclaimerOnTheLeft && renderDisclaimer && renderDisclaimer()}
            </div>
        </div>
    );
};
